"use client";
import type { PropsWithChildren } from "react";
import { BrowserSessionContext } from "./browser-session-context";
import type { BrowserSessionContextValue } from "./browser-session-state";

export function BrowserSessionScope({
  value,
  children,
}: PropsWithChildren<{
  readonly value: BrowserSessionContextValue;
}>) {
  return (
    <BrowserSessionContext value={value}>{children}</BrowserSessionContext>
  );
}
